export const INITIAL_STATE = {
  data: undefined,
  isLoading: false,
  error: null,
  hasResolved: false,
};
